<template>
  <v-main class="redeem-code-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>兑换码</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon color="black" @click="onCreate">
        <v-icon>{{ mdiPlus }}</v-icon>
      </v-btn>
    </v-app-bar>
    <v-container fluid>
      <v-row dense align="center">
        <v-col cols="12">
          <v-text-field prefix="兑换码" hide-details v-model="form.value"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense align="center">
        <v-col cols="3">
          <span>日期</span>
        </v-col>
        <v-col cols="4">
          <v-text-field v-model="form.dt_created__gte"></v-text-field>
        </v-col>
        <v-col cols="1">
          <div>至</div>
        </v-col>
        <v-col cols="4">
          <v-text-field v-model="form.dt_created__lt"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense align="center">
        <v-col cols="3">
          <span>数量</span>
        </v-col>
        <v-col cols="4">
          <v-text-field type="number" v-model="form.total_count__gte"></v-text-field>
        </v-col>
        <v-col cols="1">
          <div>至</div>
        </v-col>
        <v-col cols="4">
          <v-text-field type="number" v-model="form.total_count__lt"></v-text-field>
        </v-col>
      </v-row>
      <div class="d-flex justify-center">
        <v-btn class="mt-8 mb-4" color="primary" :width="128" @click="onQuery">查找</v-btn>
      </div>
    </v-container>
    <v-sheet class="list">
      <div class="d-flex flex-column px-4 mt-8" v-for="item in list" :key="item.id" @click="onItemClick(item.id)">
        <div class="d-flex flex-row justify-space-between align-center">
          <div class="d-flex flex-row align-center" :class="{ 'redeem-code-disabled': !item.is_enable }">
            <span class="font-weight-bold">{{ item.value }}</span>
            <span class="label-promoter" v-if="isPromoterCode(item)">推广</span>
          </div>
          <div class="font-weight-bold">{{ getProductTitle(item) }}</div>
        </div>
        <div class="d-flex flex-row justify-space-between align-center">
          <div class="text--secondary">
            <span>已用: {{ item.used_count }}</span>
            <span class="ml-2">总量: {{ item.total_count }}</span>
          </div>
          <div class="text--secondary">{{ item.dt_expiration }}</div>
        </div>
      </div>
    </v-sheet>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import { productStore } from '@/store/product'
import { redeemCodeStore } from '@/store/redeemCode'
import { mdiPlus } from '@mdi/js'
import _ from 'lodash'

function _parseDate(s) {
  return s ? new Date(s) : null
}

export default {
  name: 'RedeemCodePage',
  components: { AppbarBackIcon },
  data() {
    return {
      mdiPlus,
      form: {
        value: null,
        dt_created__gte: null,
        dt_created__lt: null,
        total_count__gte: null,
        total_count__lt: null,
      },
    }
  },
  computed: {
    list() {
      return redeemCodeStore.list
    },
  },
  async mounted() {
    await homeStore.doLoad()
    await productStore.doLoad()
  },
  methods: {
    onCreate() {
      this.$router.push('/dash/redeem-code-detail')
    },
    getProductTitle(item) {
      let product = productStore.get(item.product_id)
      return product?.name
    },
    isPromoterCode(item) {
      return !_.isNil(item.promoter_id) || !_.isNil(item.promoter)
    },
    async onQuery() {
      await redeemCodeStore.doQuery({
        value: this.form.value,
        dt_created__gte: _parseDate(this.form.dt_created__gte),
        dt_created__lt: _parseDate(this.form.dt_created__lt),
        total_count__gte: this.form.total_count__gte,
        total_count__lt: this.form.total_count__lt,
      })
    },
    onItemClick(id) {
      this.$router.push({
        path: '/dash/redeem-code-detail',
        query: { id },
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.redeem-code-page {
  .list {
    padding-bottom: 64px;
  }
  .redeem-code-disabled {
    text-decoration: line-through;
  }
  .label-promoter {
    font-size: 12px;
    margin-left: 8px;
    margin-right: 8px;
    color: @antBlue;
  }
}
</style>
